// This is a simple helper that establishes our session with Braze and
//  supports logging to that service
//
import { envConfigs } from '../envConfigs';
const braze = require('appboy-web-sdk');

export const KEY_CLIENT_ID = 'client_id';
export const KEY_USAGE_GOAL_DAYS = 'usageGoalDays';
export const KEY_USAGE_GOAL_MINUTES = 'usageGoalMinutes';
// these are only used in here so far
const KEY_REGISTRATION_DATE = 'registrationDate';
const KEY_GUI = 'gui';
const KEY_INTERFACE_LANGUAGE = 'interfaceLanguage';
const KEY_ORGANIZATION = 'organization';
const KEY_ORIGIN_LANGUAGE = 'originLanguage';
const KEY_STATUS = 'status';
const KEY_CREATION_DATE = 'creationDate';
const KEY_MODIFICATION_DATE = 'modificationDate';
const KEY_VOICE_TYPE = 'voiceType';
const KEY_ORGANIZATION_NAME = 'organizationName';
const KEY_TARGET_LANGUAGE = 'targetLanguage';
const KEY_GROUP_GUIDS = 'groupGuids';
const KEY_NAMESPACE = 'namespace';
const KEY_TERMS_AND_CONDITIONS_ACCEPT_DATE = 'termsAndConditionsAcceptDate';
const KEY_CEFR_LEVEL = 'CEFRLevel';

export const initBrazeForApp = (user) => {
  const brazeOptions = {
    enableHtmlInAppMessages: true
  };
  braze.initialize(envConfigs.engagementApiKey, brazeOptions);
};

export const initBrazeForUser = (user) => {
  const brazeOptions = {
    enableHtmlInAppMessages: true
  };
  if (user.interfaceLanguage) {
    brazeOptions.localization = user.interfaceLanguage;
  }
  braze.initialize(envConfigs.engagementApiKey, brazeOptions);

  braze.changeUser(user.gui);

  // braze-standard user info
  braze.getUser().setEmail(user.email);
  braze.getUser().setFirstName(user.firstName);
  braze.getUser().setLastName(user.lastName);
  braze.getUser().setLanguage(user.interfaceLanguage);

  // and the custom fields
  // braze.getUser().setCustomUserAttribute(KEY_CLIENT_ID, userInfo.client_id);
  braze.getUser().setCustomUserAttribute(KEY_REGISTRATION_DATE, user.registrationDate);
  braze.getUser().setCustomUserAttribute(KEY_GUI, user.gui);
  braze.getUser().setCustomUserAttribute(KEY_INTERFACE_LANGUAGE, user.interfaceLanguage);
  braze.getUser().setCustomUserAttribute(KEY_ORGANIZATION, user.organization);
  braze.getUser().setCustomUserAttribute(KEY_ORIGIN_LANGUAGE, user.originLanguage);
  braze.getUser().setCustomUserAttribute(KEY_STATUS, user.status);
  braze.getUser().setCustomUserAttribute(KEY_CREATION_DATE, user.creationDate);
  braze.getUser().setCustomUserAttribute(KEY_MODIFICATION_DATE, user.modificationDate);
  if (user.preferences) {
    braze.getUser().setCustomUserAttribute(KEY_VOICE_TYPE, user.preferences.voiceType);
  }
  braze.getUser().setCustomUserAttribute(KEY_ORGANIZATION_NAME, user.organizationName);
  if (user.targetLanguage) {
    braze.getUser().setCustomUserAttribute(KEY_TARGET_LANGUAGE, user.targetLanguage.language);
    braze.getUser().setCustomUserAttribute(KEY_CEFR_LEVEL, user.targetLanguage.level);
  }
  if (Array.isArray(user.groupGuids)) {
    braze.getUser().setCustomUserAttribute(KEY_GROUP_GUIDS, user.groupGuids.join());
  }
  braze.getUser().setCustomUserAttribute(KEY_NAMESPACE, user.namespace);
  if (user.termsAndConditionsAcceptDate) {
    braze.getUser().setCustomUserAttribute(KEY_TERMS_AND_CONDITIONS_ACCEPT_DATE, user.termsAndConditionsAcceptDate);
  } else {
    // we don't have the terms accept date as separate data but they must do it to register
    braze.getUser().setCustomUserAttribute(KEY_TERMS_AND_CONDITIONS_ACCEPT_DATE, user.registrationDate);
  }

  braze.display.automaticallyShowNewInAppMessages();
  braze.openSession();
};

export const logBrazeEvent = (eventName, payload) => {
  braze.logCustomEvent(eventName, payload);
};

export const setBrazeUserAttribute = (attributeName, value) => {
  if (attributeName && value) {
    let user = braze.getUser();
    user.setCustomUserAttribute(attributeName, value);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/engagementHelper.js